<template>
  <v-card>
    <v-card-text>
      <v-text-field
        v-model="name"
        label="Name"
        :error-messages="nameErrorMessages"
      />
      <hour-range v-model="hourRange" />
      
    </v-card-text>
    <v-card-actions>
        <v-btn color="default" text @click="doCancel">Abbrechen</v-btn>
        <v-btn color="primary" @click="doConfirm" :disabled="!valid">Speichern</v-btn>
      </v-card-actions>
  </v-card>
</template>

<script>

import HourRange from './HourRange';

export default {
  name: 'NewPause',
  props: {
  },
  components: {
    HourRange,
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    hourRange: {
      get() {
        return {from: this.from, to: this.to};
      },
      set(newValue) {
        this.from = newValue.from;
        this.to = newValue.to;
      }
    },
    valid() {
      return this.isValid();
    },
    nameErrorMessages() {
      return !this.name ? 'Pflichfeld' : null;
    },
  },
  methods: {
    doCancel() {
      this.$emit('cancel');
    },
    doConfirm() {
      const data = {
        name: this.name,
        from: this.from,
        to: this.to,
      };
      this.$emit('save', data);
    },
    isValid() {
      return !this.nameErrorMessages && this.from && this.to;
    },
  },
  data() {
    return {
      name: '',
      from: null,
      to: null,
    };
  },
};
</script>
